<svg
    width="233"
    height="250"
    viewBox="0 0 233 250"
    xmlns="http://www.w3.org/2000/svg">
    <g
        app-roof
        [type]="type()"></g>

    <g
        [x]="90"
        [y]="5"
        app-roof-vent></g>

</svg>